import React from 'react';
import { Box, Grid, GridItem, VStack, Text, Container, Flex } from '@chakra-ui/react';
import { LogoMark } from '../LogoMark';
import { Link } from '../Link';
import { DownloadLinks } from '../DownloadLinks';
import { ArrowLink } from '../ArrowLink';
import { Downloads } from '../Downloads';

export default function Footer() {
  return (
    <Box
      as='footer'
      bg='white'
      color='black'
      borderTop={1}
      borderStyle='solid'
      borderColor='gray.200'
      py={{ base: 30, xl: 60 }}
      px={{ base: 20, xl: 30 }}
    >
      <Container maxWidth='container.xl' margin='auto' padding='0'>
        <Grid
          gridTemplateColumns={{ base: '1fr', lg: '1fr 3fr 3fr 3fr' }}
          justifyContent='flex-start'
          gap={30}
        >
          <GridItem display='flex' alignItems='flex-start' color='navy'>
            <Link
              href='https://www.imf.org/'
              _hover={{
                textDecoration: 'none',
                opacity: 0.8,
              }}
              aria-label='Go to International Monetary Fund homepage'
            >
              <LogoMark isFooter />
            </Link>
          </GridItem>

          <GridItem>
            <Flex direction='column' gap='8px' alignItems='flex-start'>
              <Text textStyle='navItem'>About the IMF</Text>
              <Text>
                The International Monetary Fund (IMF) is a global organization of 191 member
                countries set up to promote the health of the world economy.
              </Text>
              <ArrowLink
                title='Learn More'
                href='https://www.imf.org/en/About/Factsheets'
                color='navy'
              />
            </Flex>
          </GridItem>

          <GridItem>
            <VStack spacing='8px' alignItems='flex-start'>
              <Text textStyle='navItem'>Download The Report</Text>
              <DownloadLinks
                display='grid'
                gridTemplateColumns='1fr 1fr'
                gap={5}
                width='100%'
                variant='footer'
              />
            </VStack>
          </GridItem>

          <GridItem>
            <VStack spacing='8px' alignItems='flex-start'>
              <Text textStyle='navItem'>Downloads</Text>
              <Downloads />
            </VStack>
          </GridItem>
        </Grid>
      </Container>
    </Box>
  );
}
